import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output
} from '@angular/core';

@Component({
  selector: 'app-group-item',
  templateUrl: './group-item.component.html',
  styleUrls: ['./group-item.component.scss']
})
export class GroupItemComponent implements OnInit {
  @Input() group: any;
  @Output() joinEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  undoJoin() {}

  subscribeToGroup() {
    this.joinEvent.emit({ id: this.group.id, subscribe: true });
    // this.group.is_subscriber = !this.group.is_subscriber;
  }

  unsubscribeFromGroup(group: any) {
    if (group.is_requested) {
      this.joinEvent.emit({ id: this.group.id, undoJoin: true });
    } else {
      this.joinEvent.emit({ id: this.group.id, subscribe: false });
    }

    // this.group.is_subscriber = !this.group.is_subscriber;
  }
}
